import { __makeTemplateObject } from '../../_virtual/_tslib.js';
import styled, { css } from 'styled-components';
import * as typography from '@tapas/typography';

/**
 * checkbox 너비 (단위: rem)
 */
var CHECKBOX_WIDTH = 2;
var CheckMark = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  width: ", "rem;\n  height: ", "rem;\n  box-sizing: border-box;\n\n  border: 1px solid\n    ", ";\n  border-radius: 2px;\n  background-color: ", ";\n\n  svg {\n    display: ", ";\n\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n\n    path {\n      fill: ", ";\n    }\n  }\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  width: ", "rem;\n  height: ", "rem;\n  box-sizing: border-box;\n\n  border: 1px solid\n    ", ";\n  border-radius: 2px;\n  background-color: ", ";\n\n  svg {\n    display: ", ";\n\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n\n    path {\n      fill: ", ";\n    }\n  }\n"])), CHECKBOX_WIDTH, CHECKBOX_WIDTH, function (_a) {
    var theme = _a.theme, isChecked = _a.isChecked;
    return isChecked
        ? theme.colorTokens.accent.default
        : theme.colorTokens.hierarchy.h3;
}, function (_a) {
    var theme = _a.theme, isChecked = _a.isChecked;
    return isChecked
        ? theme.colorTokens.accent.default
        : theme.colorTokens.background.base;
}, function (_a) {
    var isChecked = _a.isChecked;
    return (isChecked ? 'block' : 'none');
}, function (_a) {
    var theme = _a.theme;
    return theme.colorTokens.accent.on;
});
var EnabledLabel = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &:hover ", " {\n    border-color: ", ";\n  }\n"], ["\n  &:hover ", " {\n    border-color: ", ";\n  }\n"])), CheckMark, function (_a) {
    var theme = _a.theme;
    return theme.colorTokens.accent.default;
});
var DisabledLabel = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  cursor: not-allowed;\n  color: ", ";\n\n  & ~ ", " {\n    border-color: ", ";\n    background-color: ", ";\n\n    path {\n      fill: ", ";\n    }\n  }\n"], ["\n  cursor: not-allowed;\n  color: ", ";\n\n  & ~ ", " {\n    border-color: ", ";\n    background-color: ", ";\n\n    path {\n      fill: ", ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorTokens.text.disabled;
}, CheckMark, function (_a) {
    var theme = _a.theme;
    return theme.colorTokens.hierarchy.h4;
}, function (_a) {
    var theme = _a.theme;
    return theme.colorTokens.hierarchy.h5;
}, function (_a) {
    var theme = _a.theme;
    return theme.colorTokens.icon.disabled;
});
var Label = styled.label(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n  color: ", ";\n\n  display: block;\n  position: relative;\n\n  padding-left: ", "rem;\n  width: 100%;\n  box-sizing: border-box;\n\n  line-height: ", "rem;\n\n  word-break: keep-all;\n  cursor: pointer;\n\n  ", "\n  ", "\n"], ["\n  ", "\n  color: ", ";\n\n  display: block;\n  position: relative;\n\n  padding-left: ", "rem;\n  width: 100%;\n  box-sizing: border-box;\n\n  line-height: ", "rem;\n\n  word-break: keep-all;\n  cursor: pointer;\n\n  ", "\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return typography.body(theme.fonts.default, 1.4);
}, function (_a) {
    var theme = _a.theme;
    return theme.colorTokens.text.primary;
}, CHECKBOX_WIDTH + 0.8, CHECKBOX_WIDTH + 0.1, function (props) { return props.disabled && DisabledLabel; }, function (props) { return !props.disabled && EnabledLabel; });
var Input = styled.input(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: none;\n  position: absolute;\n\n  cursor: pointer;\n\n  :disabled {\n    ", "\n  }\n"], ["\n  display: none;\n  position: absolute;\n\n  cursor: pointer;\n\n  :disabled {\n    ", "\n  }\n"])), DisabledLabel);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

export { CheckMark, Input, Label };
